import { JobDetail, JobDetailValue, JobQualificationValue, Qualification } from 'models';
import { FormFieldProps } from './components/FormTypes';

export function addOrUpdateDetail(val: JobDetailValue, jobDetails: FormFieldProps<JobDetailValue[]>) {
    let newValues = [...jobDetails.value];
    let existingValue = newValues.find((existing) => existing.detail === val.detail);
    if (existingValue) {
        existingValue.value = val.value;
        existingValue.option = val.option;
    } else newValues.push(val);
    jobDetails.setValue(newValues);
}

export function addOrRemoveDetail(jobDetails: FormFieldProps<JobDetailValue[]>, detail: JobDetail, optionId?: number) {
    let newValues = [...jobDetails.value];
    let existingOptionIndex = newValues.findIndex((val) => val.detail === detail.id && val.option === optionId);
    if (existingOptionIndex >= 0) newValues.splice(existingOptionIndex, 1);
    else newValues.push({ detail: detail.id, option: optionId });
    jobDetails.setValue(newValues);
}

export function addOrUpdateQualification(
    val: JobQualificationValue,
    jobQualifications: FormFieldProps<JobQualificationValue[]>,
) {
    const { value, setValue } = jobQualifications;

    let newValues = [...value];
    let existingValue = newValues.find((existing) => existing.qualification === val.qualification);
    if (existingValue) {
        existingValue.value = val.value;
        existingValue.option = val.option;
    } else newValues.push(val);
    setValue(newValues);
}

export function addOrRemoveQualification(
    jobQualifications: FormFieldProps<JobQualificationValue[]>,
    qualification: Qualification,
    optionId?: number,
) {
    const { value, setValue } = jobQualifications;

    let newValues = [...value];
    let existingOptionIndex = newValues.findIndex(
        (val) => val.qualification === qualification.id && val.option === optionId,
    );
    if (existingOptionIndex >= 0) newValues.splice(existingOptionIndex, 1);
    else newValues.push({ qualification: qualification.id, option: optionId });
    setValue(newValues);
}
